"use strict";

class StationSettingsVisualsCtrl {
    constructor($rootScope, $http, $mdToast, $mdDialog, $state, $transitions) {
        this.$rootScope = $rootScope;
        this.$http = $http;
        this.$mdToast = $mdToast;
        this.$mdDialog = $mdDialog;
        this.$state = $state;

        this.status = {saving: false, errors: false};
        this.visuals = [];
        this.fetch();

        this.isSaved = false;
        this.firstVisit = true;

        this.$rootScope.saveDisabled = false;
        this.$rootScope.saveHiden = false;
        this.$rootScope.save = this.save.bind(this);

        this.unregisterStateChangeStart = $transitions.onStart({ }, this.stateChangeStart.bind(this));

    }

    stateChangeStart(transition) {

        let to = transition.to();
        let toParams = transition.params();

        if (!angular.equals(this.copyString, this.currentVisual) && this.isSaved == false) {
            transition.abort();
            this.$mdDialog.show({
                controller: 'ConfirmDialogCtrl',
                templateUrl: "unsavedDataDialog.ngTemplate",
                parent: angular.element(document.querySelector('#popupContainer')),
                clickOutsideToClose: true
            }).then(() => {
                this.isSaved = true;
                this.$state.go(to, toParams);
            });
        }
    }

    fetch() {
        this.visuals = [];
        this.$http.get('/station/visuals').then(response => {
            this.visuals = response.data;

            if (this.$state.params.slideId) {

                this.currentVisual = this.visuals[this.$state.params.slideId];
                this.currentIndex = this.$state.params.slideId;

                this.render(this.visuals[this.$state.params.slideId]);

                this.copyVisual = angular.copy(this.currentVisual);
            }
        });
    }

    save() {
        if (this.currentVisual.id) {
            this.$http.put('/station/visuals', this.currentVisual)
                .then(() => {
                    this.$mdToast.show({
                        templateUrl: '/partial/app.partials.toasts.object_saved?object=visuals', //@trans('labels.settings')
                        hideDelay: 6000,
                        position: ('top right')
                    });

                    this.fetch();

                    this.isSaved = true;

                });
        } else {
            this.$http.post('/station/visuals', this.currentVisual)
                .then(() => {
                    this.$mdToast.show({
                        templateUrl: '/partial/app.partials.toasts.object_saved?object=visuals', //@trans('labels.settings')
                        hideDelay: 6000,
                        position: ('top right')
                    });

                    this.fetch();

                    this.isSaved = true;

                });
        }
    }

    render(content) {
        if (content) {
            this.$http.post('station/twigpreview', content)
                .then((render) => {
                    this.renderPreview = render.data;
                });
        }
    }

    addVisual() {
        let indexContent = {
            name: 'visual',
            content: `<!doctype html>
<html>
<head>
	<style>
		* {box-sizing: border-box;}
		html,
		body {
			height: 100%;
			width: 100%;
			margin: 0;
			background:url(http://loremflickr.com/660/480/microphone);
			font-family:arial;
		}
		#bar{
		    position: absolute;
		    bottom: 10px;
		    left:15px;
		    width: 290px;
		    padding:10;
		    box-sizing:border-box  ;
		    background-image: linear-gradient(to right, rgba(255,255,255,.9) 30%, transparent 100%);
		    color: black;
		    font-weight:bold;
		    font-size:12px;
		    line-height:16px;
		}
		#bar span {
		    display:block;
		    color:#FD1686;
		}
		#logo {
		    position: absolute;
		    top:20px;
		    right: 20px;
		}
		.noa-header {
		    background:#FD1686;
		    color:#fff;
	        padding:0 10px;
	        line-height:20px;
	        position:absolute;
	        top:15px;
	        left:14px;
	        width :135px;
	        font-size:12px;
		}
		.noa-body {
		    background:rgba(255,255,255,.9);
		    padding:10px;
		    position:absolute;
		    width:135px;
		    left:15px;
		    top:40px;
		    font-size:12px;
		    line-height:16px;
		}
	</style>
</head>
<body>
    <div class="noa-header">NOW ON AIR</div>
    <div class="noa-body">
        {% if item.title is defined %}
    	    <strong>{{item.title}}</strong><br>
    	    {% if item.description is defined %}{{item.description}}<br>{% endif %}
    	    {% if item.contacts is defined %}
        	    {% for contact in item.contacts %}
                    {{ contact.firstname }} {{ contact.lastname }}<br>
                {% endfor %}
    	    {% endif %}
        {% else %}
            <strong>{{broadcast.title}}</strong><br>
            {{broadcast.description}}
        {% endif %}
    </div>
    <img id="logo" src="http://i.imgur.com/gjcfiJI.png">
    <div id="bar">
        <span>{{broadcast.title}}</span>
    	{% if broadcast.presenters is defined %}
    	    <small>
    	    {% for presenter in broadcast.presenters %}
                {{ presenter.name }}
            {% endfor %}
            </small>
        {% else %}
    	    <small>{{ "now"|date("H:i") }} on {{ "now"|date("d-m-Y") }}</small>
        {% endif %}
    </div>
</body>
</html>`
        };

        if (this.isSaved == false && this.firstVisit == false) {
            event.preventDefault();
            this.$mdDialog.show({
                controller: 'ConfirmDialogCtrl',
                templateUrl: "unsavedDataDialog.ngTemplate",
                parent: angular.element(document.querySelector('#popupContainer')),
                clickOutsideToClose: true
            }).then(() => {
                let length = this.visuals.push(indexContent);

                this.openVisual(length - 1);

                this.isSaved = false;
            });
        } else {
            let length = this.visuals.push(indexContent);

            this.openVisual(length - 1);

            this.isSaved = false;
            this.firstVisit = false;
        }
    }

    openVisual(index) {
        this.currentVisual = this.visuals[index];
        this.currentIndex = index;

        this.copyString = angular.copy(this.currentVisual);

        this.$state.transitionTo('stationsettings.visuals_strings.visuals.slide', {slideId: index});

        this.render(this.visuals[index]);
    }


    checkActiveSlide(index) {
        return this.$state.params.slideId == index;
    }

    sanitizeVisualName() {
        if (this.currentVisual.name) {
            this.currentVisual.name = this.currentVisual.name.trim().replace(/[^\w\d_]/gi, '').toLowerCase();
        }
    }

    destroy(visual, ev, index) {
        this.$mdDialog.show({
            controller: 'ConfirmDialogCtrl',
            templateUrl: 'confirmDialog.ngTemplate',
            //parent: angular.element(document.querySelector('#popupContainer')),
            targetEvent: ev,
            clickOutsideToClose: true
        }).then(() => {
            if (visual.id) {
                this.$http.delete('/station/visuals/' + visual.id);
            }

            this.visuals.splice(index, 1);

            if (this.currentIndex === index) {
                this.$state.transitionTo('stationsettings.visuals_strings.visuals');
            }
        });
    }

    openMenu($mdOpenMenu, ev) {
        $mdOpenMenu(ev);
    }
}


StationSettingsVisualsCtrl.$inject = ['$rootScope', '$http', '$mdToast', '$mdDialog', '$state', '$transitions'];


module.exports = StationSettingsVisualsCtrl;
